import { render } from "./SecurityAuthentication.vue?vue&type=template&id=32f83138&ts=true"
import script from "./SecurityAuthentication.ts?vue&type=script&lang=ts&external"
export * from "./SecurityAuthentication.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__